import React from 'react';
import { DatasetProfile } from '../domain/analytics/types';

interface DatasetHealthPanelProps {
  profile: DatasetProfile;
}

const DatasetHealthPanel: React.FC<DatasetHealthPanelProps> = ({ profile }) => {
  return (
    <section className="dataset-health panel-surface">
      <div className="section-header">
        <h3>Dataset Health</h3>
        <p>Reliability checks before publishing insights.</p>
      </div>

      <div className="health-kpis">
        <div className="health-kpi">
          <span>Rows</span>
          <strong>{profile.rowCount.toLocaleString()}</strong>
        </div>
        <div className="health-kpi">
          <span>Columns</span>
          <strong>{profile.columnCount}</strong>
        </div>
        <div className="health-kpi">
          <span>Duplicate Ratio</span>
          <strong>{(profile.duplicateRatio * 100).toFixed(1)}%</strong>
        </div>
        <div className="health-kpi">
          <span>Date Coverage</span>
          <strong>{profile.dateCoverage ? `${profile.dateCoverage.start.slice(0, 10)} -> ${profile.dateCoverage.end.slice(0, 10)}` : 'N/A'}</strong>
        </div>
      </div>

      <div className="columns-table-wrapper">
        <table className="columns-table">
          <thead>
            <tr>
              <th>Column</th>
              <th>Type</th>
              <th>Null %</th>
              <th>Unique</th>
              <th>Skewness</th>
            </tr>
          </thead>
          <tbody>
            {profile.columns.map((column) => (
              <tr key={column.name}>
                <td>{column.name}</td>
                <td>{column.type}</td>
                <td>{(column.nullRatio * 100).toFixed(1)}%</td>
                <td>{column.uniqueCount}</td>
                <td>{typeof column.skewness === 'number' ? column.skewness.toFixed(2) : 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default DatasetHealthPanel;
